export const getPercent = (value: number) => {
  const percent = value * 100
  const formattedPercent = percent % 1 !== 0 ? percent.toFixed(1) : percent

  return `${formattedPercent}%`
}

export const isLoyaltyProgramActive = () => {
  // Maybe will be active in the future: https://jira.poleinvest.ru/browse/IFA-2554
  return false
}
